var _circle, _circle2, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddEntityCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 250,
    viewBox: "0 0 251 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.501,
    cy: 125.001,
    r: 108.333,
    fill: "#BFCBFE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.917,
    cy: 125.417,
    r: 95.4167,
    fill: "#A5B6FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_537_18323)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 125.501,
    cy: 125.001,
    r: 83.3333,
    fill: "#3855CA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.793 88C124.647 88 123.515 88.2343 122.439 88.6862L82.7384 105.642C81.3938 106.227 80.5022 107.734 80.5022 109.424C80.5022 111.115 81.3938 112.621 82.7384 113.207L90.9333 116.705C88.6121 121.024 87.2958 126.129 87.2958 131.502V136.205C87.2958 140.958 85.7673 145.863 84.1396 149.729C83.2196 151.905 82.1723 154.047 80.9551 156.022C80.5022 156.742 80.3748 157.679 80.6296 158.533C80.8843 159.387 81.4788 160.023 82.2147 160.24L91.273 162.918C91.8674 163.102 92.5043 162.969 93.028 162.584C93.5517 162.199 93.9197 161.563 94.0329 160.843C95.2501 153.679 94.6415 147.252 93.7357 142.649C93.2828 140.272 92.6742 137.845 91.825 135.619V131.502C91.825 126.447 93.2686 121.676 95.7738 117.86C97.5996 115.266 99.9632 113.174 102.737 111.885L124.958 101.558C126.119 101.022 127.435 101.692 127.888 103.064C128.341 104.437 127.775 105.993 126.614 106.529L104.393 116.856C102.638 117.676 101.095 118.931 99.8358 120.471L122.425 130.112C123.5 130.564 124.633 130.799 125.779 130.799C126.926 130.799 128.058 130.564 129.134 130.112L168.848 113.207C170.193 112.638 171.084 111.115 171.084 109.424C171.084 107.734 170.193 106.227 168.848 105.642L129.148 88.6862C128.072 88.2343 126.94 88 125.793 88ZM98.6186 150.934C98.6186 156.843 110.791 162.985 125.793 162.985C140.796 162.985 152.968 156.843 152.968 150.934L150.802 126.597L130.676 135.201C129.105 135.87 127.449 136.205 125.793 136.205C124.137 136.205 122.467 135.87 120.91 135.201L100.784 126.597L98.6186 150.934Z",
    fill: "#8199F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_537_18323",
    x: 42.168,
    y: 41.668,
    width: 166.668,
    height: 170.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_537_18323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEntityCourse);
export default __webpack_public_path__ + "static/media/add-entity-course.febbfa9fb6c6ef077722a702986bea82.svg";
export { ForwardRef as ReactComponent };